import {html, LitElement, nothing} from "lit";
import {customElement, property} from "lit/decorators.js";
import {classMap} from "lit/directives/class-map.js";
import {buttonStyles} from "./Button.styles.js";
import {renderPowerNotesLogo} from "../powerNotesLogo.js";

enum BUTTON_TYPES {
	PRIMARY = "primary",
	SECONDARY = "secondary",
	LINK = "link",
	LINK_BLUE = "link-blue",
	AUTH = "auth"
};

@customElement("pn-button")
export class Button extends LitElement {
	@property({type: String})  className = "";
	@property({type: Boolean}) disabled = false;
	@property({type: String})  renderType: BUTTON_TYPES = BUTTON_TYPES.PRIMARY;
	@property()                onClick:    (event: PointerEvent) => void;
	@property({type: Boolean}) small = false;
	@property({type: Boolean}) isLoading = false;
	@property({type: String})  type = "button";
	// ..rest?

	static styles = [buttonStyles];

	static shadowRootOptions = {...LitElement.shadowRootOptions, delegatesFocus: true};

	getLogo() {
		if (this.renderType !== BUTTON_TYPES.AUTH)
			return nothing;

		return renderPowerNotesLogo();
	}

	render() {
		return html`<button
			class="${classMap({
				[`btn-${this.renderType}`]: true,
				"btn-small":                this.small,
				loading:                    this.isLoading,
				[this.className]:           true
			})}"
			@click="${this.onClick}"
			?disabled="${this.disabled}"
			part="button"
			type="${this.type}"
		>
			${this.getLogo()}
			<slot/>
			${(this.renderType === BUTTON_TYPES.PRIMARY || this.renderType === BUTTON_TYPES.SECONDARY) ? html`
				<span class="btn-loading-dots" part="loading-dots">
					<span>.</span><span>.</span><span>.</span>
				</span>
			` : null}
		</button>`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-button": Button;
	}
}
